/**
 * Functions related to search functionality
 *
 * @return void
 *
 */

import {body, searchOpenClass, activeClass, addEventListenerIfElExists} from './helpers';

export const search = () => {
	const openSearchEl = document.querySelector('.js-open-search');
	const closeSearchEl = document.querySelector('.js-close-search');
	const headerSearchFormEl = document.querySelector('.js-header-search-form');

	function openSearch(el) {
		el.preventDefault();

		body.classList.add(searchOpenClass);
		headerSearchFormEl.classList.add(activeClass);
	}

	function closeSearch(el) {
		el.preventDefault();

		body.classList.remove(searchOpenClass);
		headerSearchFormEl.classList.remove(activeClass);
	}

	addEventListenerIfElExists(openSearchEl, 'click', openSearch);
	addEventListenerIfElExists(closeSearchEl, 'click', closeSearch);
};

